import { COMPANY } from "../data/site";

export default function WhatsAppFloat() {
  return (
    <a
      href={COMPANY.whatsapp}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-40 bg-[#25D366] text-white rounded-full w-14 h-14 flex items-center justify-center wa-pulse hover:scale-110 transition-transform shadow-lg"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="currentColor" aria-hidden>
        <path d="M16 .4C7.4.4.5 7.3.5 15.9c0 2.8.7 5.5 2.1 7.9L0 32l8.5-2.6c2.3 1.3 4.9 1.9 7.5 1.9 8.6 0 15.5-6.9 15.5-15.5C31.5 7.3 24.6.4 16 .4Zm0 28c-2.4 0-4.7-.6-6.7-1.9l-.5-.3-5 1.5 1.6-4.9-.3-.5c-1.4-2.2-2.1-4.7-2.1-7.3C3 8.9 8.9 3 16 3s13 5.9 13 12.9-5.9 12.5-13 12.5Zm7.4-9.3c-.4-.2-2.4-1.2-2.7-1.3-.4-.1-.6-.2-.9.2-.3.4-1 1.3-1.3 1.6-.2.3-.5.3-.9.1-2.4-1.2-4-2.2-5.6-5-.4-.7.4-.6 1.2-2.2.1-.3 0-.5-.1-.7-.1-.2-.9-2.2-1.3-3-.3-.8-.7-.7-.9-.7H10c-.3 0-.7.1-1.1.5-.4.4-1.4 1.3-1.4 3.3 0 1.9 1.4 3.8 1.6 4.1.2.3 2.7 4.2 6.6 5.9.9.4 1.7.6 2.2.8.9.3 1.8.2 2.5.1.8-.1 2.4-1 2.7-1.9.3-.9.3-1.8.2-1.9-.1-.1-.4-.2-.8-.4Z" />
      </svg>
    </a>
  );
}
